module.exports = __webpack_public_path__ + "img/3.bf327160.png";